import { render, staticRenderFns } from "./ProductsStock.vue?vue&type=template&id=74c99fe6"
import script from "./ProductsStock.vue?vue&type=script&lang=js"
export * from "./ProductsStock.vue?vue&type=script&lang=js"
import style0 from "./ProductsStock.vue?vue&type=style&index=0&id=74c99fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports